import React from 'react';
import { message, Table, Button, Col, Row, DatePicker, Select, Tag } from 'antd';
import queryString from 'query-string';
import moment from 'moment';
import { utils } from 'utils';
import { api, soloMuevenCaja } from './api';
import Nuevo from './Nuevo';

const Option = Select.Option;

// Saldo, desglose por forma de pago y movimientos de la caja de un usuario.
// Lo usan tanto "Mi caja" (usuario logueado) como "Consulta de cajas" (admin).
class DetalleCaja extends React.Component {

	constructor(props) {
		super(props)
		this.state = {
			saldo: null,
			desglose: [],
			data: [],
			desde: '',
			hasta: '',
			codforpago: undefined,
			formasPago: [],
			// saldo corrido que devuelve el endpoint de movimientos
			arrastre: 0,
			saldofinal: 0,
			pagination: { showSizeChanger: true, pageSizeOptions: ['10', '25', '50', '100'] },
			columns: [
				{
					title: 'Código',
					dataIndex: 'id',
					key: 'id',
					width: 20,
				},
				{
					// el endpoint ordena siempre por fecha, solo se elige la direccion
					title: 'Fecha',
					dataIndex: 'fecha',
					sorter: true,
					key: 'fecha',
					width: 140,
					render: (col, row) => utils.fechaHora(row.fecha),
				},
				{
					title: 'Tipo',
					dataIndex: 'tipo',
					key: 'tipo',
					width: 90,
					render: (col, row) => row.tipo === "I"
						? <Tag color="green">Ingreso</Tag>
						: <Tag color="red">Egreso</Tag>,
				},
				{
					title: 'Concepto',
					dataIndex: 'concepto',
					key: 'concepto',
					width: 280,
					render: (col, row) => row.concepto || '',
				},
				{
					title: 'Forma de pago',
					dataIndex: 'formapago',
					key: 'formapago',
					width: 160,
					render: (col, row) => row.formapago || '',
				},
				{
					title: 'Importe',
					dataIndex: 'importe',
					key: 'importe',
					width: 110,
					render: (col, row) => `$ ${utils.currency(row.importe)}`,
				},
				{
					title: 'Origen',
					dataIndex: 'origen',
					key: 'origen',
					width: 110,
					render: (col, row) => row.origen === "manual"
						? <Tag>manual</Tag>
						: <Tag color="orange">{row.origen || ''}</Tag>,
				},
				{
					// saldoparcial es el acumulado del conjunto filtrado, no el global
					title: 'Saldo',
					dataIndex: 'saldoparcial',
					key: 'saldoparcial',
					width: 120,
					render: (col, row) => `$ ${utils.currency(row.saldoparcial)}`,
				},
			],
		}
	}

	componentDidMount() {
		this.fetchFormasPago();
		this.recargar();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.idusuario !== this.props.idusuario) {
			this.setState({ desde: '', hasta: '', codforpago: undefined }, this.recargar);
		}
	}

	recargar = () => {
		this.fetchSaldo();
		this.fetchDesglose();
		this.fetch({ limite: 10, pagina: 1 });
	}

	fetchFormasPago = async () => {
		try {
			const response = await api.mpago.getAll(queryString.stringify({
				pagina: 1,
				limite: 500,
			}));
			if (response.status === "success") {
				const data = response.data || {};
				this.setState({
					formasPago: soloMuevenCaja(data.formasPago)
				});
			}
		} catch (e) {
			message.error(e.toString(), 5);
		}
	}

	fetchSaldo = async () => {
		try {
			const response = await api.caja.saldo(this.props.idusuario);
			if (response.status === "success") {
				this.setState({ saldo: (response.data && response.data.saldo) || 0 });
			} else {
				message.error(response.message, 5);
			}
		} catch (e) {
			message.error(e.toString(), 5);
		}
	}

	fetchDesglose = async () => {
		try {
			const response = await api.caja.desglose(this.props.idusuario);
			if (response.status === "success") {
				this.setState({ desglose: (response.data && response.data.desglose) || [] });
			} else {
				message.error(response.message, 5);
			}
		} catch (e) {
			message.error(e.toString(), 5);
		}
	}

	handleTableChange = (pagination, filters, sorter) => {
		const pager = { ...this.state.pagination };
		pager.current = pagination.current;
		this.setState({ pagination: pager });
		this.fetch({
			limite: pagination.pageSize,
			pagina: pagination.current,
			// el orden es siempre por fecha: solo se elige la direccion
			sortOrder: sorter.order === "descend" ? "DESC" : "ASC",
			...filters,
		});
	}

	fetch = async (params = {}) => {
		try {
			const filtros = {};
			if (this.state.desde !== '' && this.state.hasta !== '') {
				filtros.desde = moment.parseZone(this.state.desde).format("YYYY-MM-DD");
				filtros.hasta = moment.parseZone(this.state.hasta).format("YYYY-MM-DD");
			}
			if (this.state.codforpago !== undefined && this.state.codforpago !== null) {
				filtros.codforpago = this.state.codforpago;
			}
			const response = await api.caja.getAll(queryString.stringify({
				...params,
				...filtros,
				idusuario: this.props.idusuario,
			}))
			const pagination = { ...this.state.pagination };
			if (response.status === "success") {
				// sin movimientos el backend responde data vacio en vez de un objeto
				const data = response.data || {};
				pagination.total = parseInt(data.registros) || 0;
				this.setState({
					data: data.movimientos || data.caja || [],
					arrastre: data.arrastre || 0,
					saldofinal: data.saldofinal || 0,
					pagination
				});
			} else {
				this.setState({ data: [], arrastre: 0, saldofinal: 0 });
				message.error(response.message, 5);
			}
		} catch (e) {
			this.setState({ data: [], arrastre: 0, saldofinal: 0 });
			message.error(e.toString(), 5);
		}
	}

	filtrar = () => {
		const pager = { ...this.state.pagination };
		pager.current = 1;
		this.setState({ pagination: pager });
		this.fetch({ limite: 10, pagina: 1 });
	}

	closeNuevo = (saldo) => {
		this.setState({ openNuevo: false });
		if (saldo !== undefined && saldo !== null) {
			// la respuesta del alta ya trae el saldo actualizado
			this.setState({ saldo });
			this.fetchDesglose();
			this.fetch({ limite: 10, pagina: 1 });
		}
	}

	render() {
		let columns = [...this.state.columns];
		const { titulo } = this.props;
		return (
			<div>
				<div className="box box-default" style={{ marginTop: 15 }}>
					<div className="box-body">
						<Row>
							<Col sm={{ span: 12 }} xs={{ span: 24 }}>
								<h4 style={{ marginBottom: 5 }}>{titulo || 'Caja'}</h4>
								<h2 style={{ marginBottom: 0 }}>
									$ {this.state.saldo !== null ? utils.currency(this.state.saldo) : '-'}
								</h2>
							</Col>
							<Col sm={{ span: 12 }} xs={{ span: 24 }}>
								<Table
									size="small"
									bordered={false}
									pagination={false}
									rowKey={(record, index) => index}
									columns={[
										{ title: 'Forma de pago', dataIndex: 'formapago', key: 'formapago' },
										{
											title: 'Saldo', dataIndex: 'saldo', key: 'saldo',
											render: (col, row) => `$ ${utils.currency(row.saldo)}`
										},
									]}
									dataSource={this.state.desglose}
								/>
							</Col>
						</Row>
					</div>
				</div>

				<div className="box box-default box-ant-table-v1" style={{ marginTop: 15 }}>
					<div className="box-body">
						<h4 style={{ marginBottom: 15, display: 'inline-block' }}>Movimientos</h4>
						<Button
							type="primary"
							icon="plus"
							onClick={() => this.setState({ openNuevo: true })}
							style={{ float: 'right' }}>
							Nuevo movimiento
						</Button>
						<Row gutter={8} style={{ marginBottom: 10 }}>
							<Col sm={{ span: 5 }} xs={{ span: 24 }}>
								<DatePicker
									value={this.state.desde !== '' ? this.state.desde : null}
									placeholder="Desde"
									format="DD/MM/YYYY"
									style={{ width: '100%' }}
									onChange={(e) => { this.setState({ desde: e != null ? moment.parseZone(e) : "" }) }}
								/>
							</Col>
							<Col sm={{ span: 5 }} xs={{ span: 24 }}>
								<DatePicker
									value={this.state.hasta !== '' ? this.state.hasta : null}
									placeholder="Hasta"
									format="DD/MM/YYYY"
									style={{ width: '100%' }}
									onChange={(e) => { this.setState({ hasta: e != null ? moment.parseZone(e) : "" }) }}
								/>
							</Col>
							<Col sm={{ span: 6 }} xs={{ span: 24 }}>
								<Select
									style={{ width: '100%' }}
									placeholder="Todas las formas de pago"
									value={this.state.codforpago}
									optionFilterProp="children"
									showSearch
									allowClear
									filterOption={(input, option) =>
										String(option.props.children || "").toLowerCase().indexOf(input.toLowerCase()) >= 0
									}
									onChange={(e) => this.setState({ codforpago: e })}
								>
									{this.state.formasPago.map((data, index) => (
										<Option value={data.codigofpag} key={index}>{data.descrifpag}</Option>
									))}
								</Select>
							</Col>
							<Col sm={{ span: 4 }} xs={{ span: 24 }}>
								<Button icon="search" onClick={this.filtrar}>Filtrar</Button>
							</Col>
						</Row>
						<Table
							bordered={false}
							columns={columns}
							rowKey={(record, index) => index}
							dataSource={this.state.data && this.state.data}
							pagination={this.state.pagination}
							onChange={this.handleTableChange}
							rowClassName={(record) => record.origen && record.origen !== "manual" ? 'autoRow' : ''}
							title={() => (
								<div style={{ textAlign: 'right' }}>
									Saldo anterior: <b>$ {utils.currency(this.state.arrastre)}</b>
								</div>
							)}
							footer={() => (
								<div style={{ textAlign: 'right' }}>
									Saldo final: <b>$ {utils.currency(this.state.saldofinal)}</b>
								</div>
							)}
						/>
					</div>
				</div>
				{this.state.openNuevo &&
					<Nuevo
						idusuario={this.props.idusuario}
						closeModal={this.closeNuevo}
					/>
				}
			</div>
		);
	}
}

export default DetalleCaja;
